import { generateSignature } from "./crypto";

export const fetchProvider = async (providerId: string, appId: string, appSecret: string) => {
  const timestamp = Date.now();
  const signature = await generateSignature(appSecret, providerId, timestamp);

  try {
    const response = await fetch(
      `https://api.reclaimprotocol.org/api/applications/${appId}/provider/${providerId}`,
      {
        method: "POST",
        headers: {
          accept: "*/*",
          "accept-language": "en-GB,en-US;q=0.9,en;q=0.8",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          signature: signature,
          timestamp: timestamp,
        }),
      }
    );

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      console.error("Request failed with status:", response.status);
    }
  } catch (error) {
    console.error("Error:", error);
  }
  return undefined;
};
